import axios from "axios";
import Api, { authUser } from "../../../../services/ServiceApi";
import moment from "moment";
const auth = authUser();
const { companyId, operatorId, projectId, username, token } = auth;
export const dynamicExternalFunction = {
  CallExternalAPI: function (path, job_id, job_progress_detail_id) {
    if (job_progress_detail_id) {
      return axios.post(
        `${process.env.REACT_APP_URL_EXTERNAL_BASE}${path}`,
        {
          company_id: companyId,
          operator_id: operatorId,
          project_id: projectId,
          job_id: job_id,
          job_progress_detail_id: job_progress_detail_id,
        },
        {
          headers: {
            "Content-type": "application/json",
            TokenUser: token,
          },
        }
      );
    } else {
      return axios.post(
        `${process.env.REACT_APP_URL_EXTERNAL_BASE}${path}`,
        {
          company_id: companyId,
          operator_id: operatorId,
          project_id: projectId,
          job_id: job_id,
        },
        {
          headers: {
            "Content-type": "application/json",
            TokenUser: token,
          },
        }
      );
    }
  },
  callExternalUrlApprove: function (path, job_id, approve_id) {
    return axios.post(
      `${process.env.REACT_APP_URL_EXTERNAL_BASE}${path}`,
      {
        company_id: companyId,
        operator_id: operatorId,
        project_id: projectId,
        job_id: job_id,
        approve_id: approve_id,
      },
      {
        headers: {
          "Content-type": "application/json",
          TokenUser: token,
        },
      }
    );
  },
};

export const CallActionBtn = {
  callbtnMideware: function (functionName, workflow, data, external) {
    if (workflow) {
    } else {
      return new Promise((resolve, reject) => {
        this[functionName](data).then((res) => {
          const { result } = res.data;
          if (result.code === "P") {
            if (external && external !== "" && external !== "{}") {
              const { companyId, operatorId, projectId, job_id } = data;
              this.callExternalUrl(
                external,
                companyId,
                operatorId,
                projectId,
                job_id
              )
                .then((res) => {
                  const { Result } = res.data;
                  if (Result.code === "P") {
                    resolve({
                      success: true,
                      msg: "Success Action || Call External URL Success",
                    });
                  } else {
                    reject({
                      success: false,
                      msg:
                        "Success Action || Call External URL Fail" +
                        Result.showText,
                    });
                  }
                })
                .catch((err) =>
                  reject({
                    success: false,
                    msg: "Success Action || Call External URL Fail" + err,
                  })
                );
            } else {
              resolve({
                success: true,
                msg: "Success",
              });
            }
          } else {
            reject({
              success: false,
              msg: result.showText,
            });
          }
        });
      });
    }
  },
  getAlarmdetail: function (job_id, approve_id) {
    return new Promise((resolve, reject) => {
      Api.post("Approve/get_approve_process", {
        approve_id: approve_id,
      }).then((res) => {
        const { data } = res.data;
        const approve_status_id = data?.approve_Process[0]?.approve_status_id;
        Api.post("job_detail/get_job_detail", {
          job_id: job_id,
          company_id: companyId,
          operator_id: operatorId,
          project_id: projectId,
        }).then((res) => {
          if (res.data.data.job_detail[0]) {
            const dataTocall = res.data.data.job_detail[0];
            Api.post("getButtonDetailWeb", {
              ActionID: 1,
              CompanyID: companyId,
              JobTypeID: dataTocall.job_type_id,
              MainProcessID: dataTocall.main_process_id,
              ProjectID: projectId,
              SubProcessID: dataTocall.subprocessid,
              UserName: username,
              Version: 1,
              WF_ID: 0,
              operator_id: operatorId,
            })
              .then((res) => {
                const { result, return_nextWorkFlow } = res.data;
                if (result.code === "P") {
                  if (approve_status_id === 1) {
                    this.sendAlarmNetwork(
                      return_nextWorkFlow?.filter(
                        (s) => s.next_main_action_id === 29
                      )[0],
                      dataTocall,
                      1
                    ).then((res) => {
                      const { result } = res.data;
                      if (result.code === "P") {
                        resolve({ result: result });
                      } else {
                        reject({ result: result });
                      }
                    });
                  } else if (approve_status_id === 2) {
                    this.sendAlarmNetwork(
                      return_nextWorkFlow?.filter(
                        (s) => s.next_main_action_id === 30
                      )[0],
                      dataTocall,
                      2
                    ).then((res) => {
                      const { result } = res.data;
                      if (result.code === "P") {
                        resolve({ result: result });
                      } else {
                        reject({ result: result });
                      }
                    });
                  } else if (approve_status_id === 3) {
                    resolve({ result: result });
                  }
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        });
      });
    });
  },
  sendAlarmNetwork: function (workflow, job, type) {
    return Api.post("job_detail/InsertAlarmNetwork", {
      company_id: companyId,
      operator_id: operatorId,
      project_id: projectId,
      job_id: job.job_id,
      job_type_id: job.job_type_id,
      job_category_id: job.job_category_id,
      job_progress_id: job.job_progress_id,
      oper_job_alarm_network_type_id: type,
      oper_job_alarm_network_type_desc: "",
      create_by: username,
      ...workflow,
    });
  },
  callGonext: function (
    workflow,
    operator_id,
    project_id,
    job_id,
    job_progress_id,
    job_type_id
  ) {
    return new Promise((resolve, reject) => {
      Api.post("/job_detail/go_next_process", {
        ...workflow,
        operator_id,
        project_id,
        job_id,
        job_progress_id,
        location_lat: 0,
        location_long: 0,
        create_by: username,
        job_type_id,
      })
        .then((res) => {
          const { result } = res.data;
          if (result.code === "P") {
            resolve({
              success: true,
              msg: result?.showText,
            });
          } else {
            reject({
              success: false,
              msg: result?.showText,
            });
          }
        })
        .catch((err) =>
          reject({
            success: false,
            msg: err,
          })
        );
    });
  },
  checkExternal: function (approveResdata, job_id, approve_id) {
    return new Promise((resolve, reject) => {
      if (
        approveResdata.process_Status[0]?.data_dynamic &&
        approveResdata.process_Status[0]?.data_dynamic !== "" &&
        approveResdata.process_Status[0]?.data_dynamic !== "{}"
      ) {
        const exurl = JSON.parse(approveResdata.process_Status[0].data_dynamic);
        const { api_url } = exurl.external_url[0];
        dynamicExternalFunction
          .callExternalUrlApprove(api_url, job_id, approve_id)
          .then((res3) => {
            const { Result } = res3.data;
            if (Result.Code === "P") {
              resolve({
                success: true,
                msg: "Success Action || Call External URL Success",
              });
            } else {
              reject({
                success: false,
                msg:
                  "Success Action || Call External URL Fail" + Result.ShowText,
              });
            }
          })
          .catch((err) =>
            reject({
              success: false,
              msg: "Success Action || Call External URL Fail" + err,
            })
          );
      } else {
        resolve({
          success: true,
          msg: "Success",
        });
      }
    });
  },
  callApproveProcess: function (
    approve_id,
    last_approve_level_seq,
    type,
    reason,
    remark,
    job_id,
    mode,
    detail,
    workFlow = {}
  ) {
    console.log("workFlow",workFlow)
    return new Promise((resolve, reject) => {
      this["sendApproveProcess"](
        approve_id,
        last_approve_level_seq,
        type,
        reason,
        remark,
        job_id,
        mode,
        workFlow
      ).then((res) => {
        console.log("callApproveProcess");
        console.log("mode", mode);
        const { result: resultSendApprove, data: approveResdata } = res.data;
        if (resultSendApprove.code === "P") {
          switch (mode) {
            case "acceptance":
              resolve({ success: true });
              break;
            case "normal":
              this.checkExternal(approveResdata, job_id, approve_id)
                .then((respone) => {
                  if (respone.success) {
                    resolve(respone);
                  } else {
                    reject(respone);
                  }
                })
                .catch((err) => reject(err));
              break;
            case "alarm":
              this.checkExternal(approveResdata, job_id, approve_id)
                .then((respone) => {
                  if (respone.success) {
                    resolve(respone);
                  } else {
                    reject(respone);
                  }
                })
                .catch((err) => reject(err));
              // this.getAlarmdetail(job_id, approve_id).then((res2) => {
              //   const { result } = res2;
              //   if (result.code === "P") {
              //     this.checkExternal(approveResdata, job_id, approve_id)
              //       .then((respone) => {
              //         if (respone.success) {
              //           resolve(respone);
              //         } else {
              //           reject(respone);
              //         }
              //       })
              //       .catch((err) => reject(err));
              //   } else {
              //     reject({
              //       success: false,
              //       msg: result.showText,
              //     });
              //   }
              // });
              break;
            case "rejectAcceptance":
              Api.post("Approve/get_approve_process", {
                approve_id: approve_id,
              }).then((resD) => {
                const { data } = resD.data;
                const approve_status_id =
                  data?.approve_Process[0]?.approve_status_id;
                if (approve_status_id === 2) {
                  console.log(detail);
                  this.callGonext(
                    detail.wf,
                    detail.operator_id,
                    detail.project_id,
                    detail.job_id,
                    detail.job_progress_id,
                    detail.job_type_id
                  ).then((resP) => {
                    if (resP?.success) {
                      this.checkExternal(approveResdata, job_id, approve_id)
                        .then((respone) => {
                          if (respone.success) {
                            resolve(respone);
                          } else {
                            reject(respone);
                          }
                        })
                        .catch((err) => reject(err));
                    } else {
                      reject(resP);
                    }
                  });
                } else {
                  resolve({ success: true, msg: "Success" });
                }
              });

              break;
            default:
              return null;
          }
        } else {
          reject({
            success: false,
            msg: resultSendApprove.showText,
          });
        }
      });
    });
  },
  sendApproveProcess: function (
    approve_id,
    last_approve_level_seq,
    type,
    reason,
    remark,
    job_id,
    mode,
    workFlow
  ) {
    return Api.post("Approve/update_approve_process_status", {
      ...workFlow,
      company_id: auth.companyId,
      operator_id: auth.operatorId,
      project_id: auth.projectId,
      create_by: auth.username,
      approve_id: approve_id,
      approve_level_seq: last_approve_level_seq,
      approve_date: moment().format("YYYY-MM-DD HH:mm:ss"),
      approve_status_id: Number(type),
      status_reason_id: Number(reason),
      status_remark: remark,
      job_id: job_id,
      // job_type_id: 14,
      // job_category_id: 1,
      // job_progress_id: 26,
      oper_job_alarm_network_type_id: Number(type), // 1 =  approve, 2 = reject
      oper_job_alarm_network_type_desc: "",
      mode: mode,
    });
  },
  callExternalUrl: function (
    external,
    CompanyId,
    OperatorId,
    ProjectId,
    job_id
  ) {
    if (external && external.length > 0) {
      external
        .filter(
          (s) =>
            s.external_config.company_id == CompanyId &&
            s.external_config.operator_id == OperatorId &&
            s.external_config.project_id == ProjectId
        )
        .map((datas) => {
          const data = datas.external_config;
          if (
            data.external_name &&
            data.external_name !== "" &&
            data.api_url &&
            data.api_url !== ""
          ) {
            return dynamicExternalFunction[data.external_name](
              data.api_url,
              job_id
            );
          }
        });
    }
  },
  stopTime: function (
    workflow,
    CompanyId,
    OperatorId,
    ProjectId,
    job_id,
    job_progress_id,
    job_type_id,
    Progress_type_id,
    service_ma_reason_id,
    stop_time,
    start_time,
    reason,
    remark
  ) {
    return new Promise((resolve, reject) => {
      Api.post("job_detail/update_oper_job_stoptime", {
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
        job_id: job_id,
        job_progress_id: job_progress_id || workflow.from_main_process_id,
        is_active: "",
        Progress_type_id: Progress_type_id,
        service_ma_reason_id: service_ma_reason_id,
        job_stop_start: stop_time,
        job_stop_end: start_time,
        job_stop_reason: reason,
        job_stop_remark: remark,
        create_by: username,
        location_lat: "0",
        location_long: "0",
        progress_Status_flag: "",
        jobtypeid: job_type_id,
        ...workflow,
      })
        .then((res) => {
          const { result, data } = res.data;
          if (result.code === "P") {
            if (
              workflow.external_url_type &&
              workflow.external_url_type === "json"
            ) {
              this.callExternalUrl(
                JSON.parse(workflow.external_url),
                CompanyId,
                OperatorId,
                ProjectId,
                job_id
              ).then((res) => {
                const { Result } = res.data;
                if (Result.code === "P") {
                  resolve({
                    success: true,
                    showText:
                      "ทำการส่งข้อมูลหยุดเวลา และส่งข้อมูลไปที่ระบบ Interface แล้ว",
                    stop_time_id: data,
                  });
                } else {
                  resolve({
                    success: true,
                    showText: "ทำการส่งข้อมูลหยุดเวลาแล้ว " + Result.showText,
                    stop_time_id: data,
                  });
                }
              });
            } else {
              resolve({
                success: true,
                showText: "ทำการส่งข้อมูลหยุดเวลาแล้ว",
                stop_time_id: data,
              });
            }
          } else {
            reject({
              success: false,
              showText: result.showText,
              stop_time_id: null,
            });
          }
        })
        .catch((err) =>
          reject({ success: false, showText: err, stop_time_id: null })
        );
    });
  },
};
